"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUsageTracker = exports.useTargetOptinViewChangedEffect = exports.useOptStateChangedEffect = exports.useInitialOptStateFetchedEffect = exports.useUpdateUserOptSettingsEffect = exports.useFetchUserOptSettingsEffect = exports.changed = exports.updateValues = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = require("react");

var _Tracking = require("ui-addon-opt/lib/Tracking");

var _OptActions = require("ui-addon-opt/state/OptActions");

var _OptState = require("ui-addon-opt/state/OptState");

var _OptinsAPI = require("ui-addon-opt/api/OptinsAPI");

var updateValues = function updateValues(ref, values) {
  ref.current = (0, _extends2.default)({}, values);
};

exports.updateValues = updateValues;

var changed = function changed(ref, values) {
  return Object.keys(values).some(function (key) {
    return ref.current[key] !== values[key];
  });
};

exports.changed = changed;

var toStateType = function toStateType(availability) {
  return availability.hubLevelOverride ? _OptState.TARGET_TYPE_HUB : availability.targetType;
};

var useFetchUserOptSettingsEffect = function useFetchUserOptSettingsEffect(_ref) {
  var dispatch = _ref.dispatch,
      optinName = _ref.optinName,
      optinView = _ref.optinView,
      onFetchOptError = _ref.onFetchOptError,
      state = _ref.opt.state,
      setOptSettings = _ref.setOptSettings;
  var fetchRef = (0, _react.useRef)({});
  (0, _react.useEffect)(function () {
    var values = {
      optinName: optinName,
      optinView: optinView,
      state: state || fetchRef.current.state // Avoid fetch when reset to null

    };

    if (changed(fetchRef, values)) {
      (0, _OptinsAPI.fetchUserOptSettings)(optinName).then(function (settings) {
        dispatch({
          type: _OptActions.ACTION_INIT_OPT,
          settings: settings
        });
        setOptSettings(settings);
      }, onFetchOptError);
    }

    updateValues(fetchRef, values);
  }, [dispatch, optinName, optinView, onFetchOptError, state, setOptSettings]);
};

exports.useFetchUserOptSettingsEffect = useFetchUserOptSettingsEffect;

var useUpdateUserOptSettingsEffect = function useUpdateUserOptSettingsEffect(_ref2) {
  var ConfirmationModal = _ref2.ConfirmationModal,
      dispatch = _ref2.dispatch,
      optinName = _ref2.optinName,
      onOptStateChangeCancelled = _ref2.onOptStateChangeCancelled,
      onUpdateOptError = _ref2.onUpdateOptError,
      choice = _ref2.opt.choice,
      optSettings = _ref2.optSettings;
  var updateRef = (0, _react.useRef)({});
  (0, _react.useEffect)(function () {
    var values = {
      choice: choice
    };

    if (choice && changed(updateRef, values)) {
      var updateOptinWithChoice = function updateOptinWithChoice() {
        (0, _OptinsAPI.updateOpt)({
          optinName: optinName,
          newOptinState: _OptState.OPT_CHOICE_TO_STATE_VALUE[choice],
          hubOverride: (0, _OptState.isUserOptin)(optSettings.availability.targetType) && (0, _OptState.isHubWideChoice)(choice),
          availability: optSettings.availability
        }).then(function () {
          return dispatch({
            type: _OptActions.ACTION_STATE_UPDATED
          });
        }, onUpdateOptError);
      };

      if (ConfirmationModal) {
        ConfirmationModal({
          optState: optSettings.availability.state
        }).then(function () {
          updateOptinWithChoice();
        }, function () {
          onOptStateChangeCancelled(optSettings.availability.state, choice);
          dispatch({
            type: _OptActions.ACTION_CHOICE_RESET
          });
        });
        return;
      }

      updateOptinWithChoice();
    }

    updateValues(updateRef, values);
  }, [ConfirmationModal, choice, dispatch, optinName, onOptStateChangeCancelled, onUpdateOptError, optSettings.availability, optSettings.availability.state]);
};

exports.useUpdateUserOptSettingsEffect = useUpdateUserOptSettingsEffect;

var useInitialOptStateFetchedEffect = function useInitialOptStateFetchedEffect(_ref3) {
  var onInitialOptStateFetched = _ref3.onInitialOptStateFetched,
      availability = _ref3.optSettings.availability;
  var invokedRef = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    if (availability.state && !invokedRef.current) {
      onInitialOptStateFetched({
        value: availability.state,
        type: toStateType(availability)
      });
      invokedRef.current = true;
    }
  }, [onInitialOptStateFetched, availability]);
};

exports.useInitialOptStateFetchedEffect = useInitialOptStateFetchedEffect;

var useOptStateChangedEffect = function useOptStateChangedEffect(_ref4) {
  var state = _ref4.opt.state,
      onOptStateChanged = _ref4.onOptStateChanged,
      optinName = _ref4.optinName,
      usageTracker = _ref4.usageTracker;
  var changeRef = (0, _react.useRef)({});
  (0, _react.useEffect)(function () {
    var values = {
      state: state
    };

    if (state && changed(changeRef, values)) {
      onOptStateChanged({
        value: _OptState.OPT_CHOICE_TO_STATE_VALUE[state],
        type: _OptState.OPT_CHOICE_TO_TARGET_TYPE[state]
      });
      (0, _Tracking.trackOptAction)(usageTracker, optinName, state);
    }

    updateValues(changeRef, values);
  }, [onOptStateChanged, optinName, state, usageTracker]);
};

exports.useOptStateChangedEffect = useOptStateChangedEffect;

var useTargetOptinViewChangedEffect = function useTargetOptinViewChangedEffect(_ref5) {
  var onTargetOptinViewChanged = _ref5.onTargetOptinViewChanged,
      _ref5$opt = _ref5.opt,
      targetOptinView = _ref5$opt.optinView,
      state = _ref5$opt.state,
      optSettings = _ref5.optSettings,
      optinView = _ref5.optinView,
      notifyOnUserViewChangesOnly = _ref5.notifyOnUserViewChangesOnly;
  var changedRef = (0, _react.useRef)({});
  var targetOptinViewRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var values = {
      targetOptinView: targetOptinView,
      availabilityState: optSettings.availability.state
    };

    if (targetOptinView && optSettings.availability.state && changed(changedRef, values)) {
      if (targetOptinViewRef.current !== targetOptinView && (!notifyOnUserViewChangesOnly || optinView !== targetOptinView)) {
        var optState = {
          value: _OptState.OPT_CHOICE_TO_STATE_VALUE[state] || optSettings.availability.state,
          type: _OptState.OPT_CHOICE_TO_TARGET_TYPE[state] || toStateType(optSettings.availability)
        };
        onTargetOptinViewChanged(targetOptinView, optState);
        targetOptinViewRef.current = targetOptinView;
      }
    }

    updateValues(changedRef, values);
  }, [targetOptinView, onTargetOptinViewChanged, optSettings.availability.state, optSettings.availability.targetType, state, optinView, optSettings.availability, notifyOnUserViewChangesOnly]);
};

exports.useTargetOptinViewChangedEffect = useTargetOptinViewChangedEffect;

var useUsageTracker = function useUsageTracker() {
  var tracker = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Tracking.emptyTracker;

  var _useState = (0, _react.useState)(_Tracking.emptyTracker),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      usageTracker = _useState2[0],
      setUsageTracker = _useState2[1];

  (0, _react.useEffect)(function () {
    setUsageTracker((0, _Tracking.cloneTracker)(tracker));
  }, [tracker]);
  return usageTracker;
};

exports.useUsageTracker = useUsageTracker;